import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import history from "../../../core/helper/Helper";

import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { RouterName } from "shared/RouterName";
import {
  LOCAL_STORAGE_CARTS,
  LOCAL_STORAGE_INFORMATION_CART,
} from "shared/Constants";
import ToastCustom from "shared/components/ToastCustom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return [
    { value: "Kiểm tra đơn hàng", key: `${RouterName.Payment.Cart.key}` },
    { value: "Địa chỉ giao hàng", key: `${RouterName.Payment.Checkout.key}` },
    {
      value: "Thanh toán & Đặt mua",
      key: `${RouterName.Payment.Completed.key}`,
    },
  ];
}

const CartStep = () => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const match = useRouteMatch();
  const steps = getSteps();

  useEffect(() => {
    const keyFromURL = match.path.split("/")[match.path.split("/").length - 1];

    if (keyFromURL) {
      passToStep(keyFromURL);
      setActiveStep(
        steps.findIndex((item) => {
          return item.key === keyFromURL;
        })
      );
    }
  }, []);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const handleStep = (step) => () => {
    history.push(`/payment/${getSteps()[step].key}`);
  };

  return (
    <div className={classes.root}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label.key}>
            <StepButton
              onClick={handleStep(index)}
              completed={completed[index]}
            >
              {label.value}
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

const passToStep = (key) => {
  if (key === RouterName.Payment.Checkout.key) {
    if (
      !localStorage.getItem(LOCAL_STORAGE_CARTS) ||
      !JSON.parse(localStorage.getItem(LOCAL_STORAGE_CARTS)).length
    ) {
      ToastCustom.warning("Chưa có nào sản phẩm trong giỏ hàng!");
      history.push(RouterName.Payment.Cart.url);
    }
  }

  if (key === RouterName.Payment.Completed.key) {
    if (
      !localStorage.getItem(LOCAL_STORAGE_CARTS) ||
      !JSON.parse(localStorage.getItem(LOCAL_STORAGE_CARTS)).length
    ) {
      ToastCustom.warning("Chưa có nào sản phẩm trong giỏ hàng!");
      history.push(RouterName.Payment.Cart.url);
    } else if (!localStorage.getItem(LOCAL_STORAGE_INFORMATION_CART)) {
      ToastCustom.warning("Vui lòng hoàn thành thông tin giao hàng!");
      history.push(RouterName.Payment.Checkout.url);
    }
  }
};

export default CartStep;
